import { PdSiteHeader } from "./pd-site-header/PdSiteHeader.js";
//#region src/pd-site-header/pd-site-header.ts
var tag = "pd-site-header";
if (!customElements.get(tag)) customElements.define(tag, PdSiteHeader);
//#endregion
export { PdSiteHeader };
